import Head from "next/head";
import Maintenance from "../components/Maintenance";
import "../styles/index.css";

function MyApp({ Component, pageProps }) {
  if (process.env.MAINTENANCE_MODE && false) {
    return (
      <>
        <Head>
          <title>BPI eADA</title>
          <link rel="icon" href="/favicon.png" />
          <link
            href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&display=swap"
            rel="stylesheet"
          />
        </Head>
        <Maintenance />
      </>
    );
  }

  return (
    <>
      <Head>
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&display=swap"
          rel="stylesheet"
        />
      </Head>
      <Component {...pageProps} />
    </>
  );
}

export default MyApp;
